import React, { useState, useEffect } from "react";
import { setGroupFilter, setTalkgroupFilter, setAllFilter, setStarredFilter, setFilterRows, setFilterTimeframe } from "../../features/callPlayer/callPlayerSlice";
import AdvancedFilter, { newRow } from "./AdvancedFilter";
import { useGetGroupsQuery, useGetTalkgroupsQuery, useGetFavoritesQuery, useAddFavoriteMutation, useRemoveFavoriteMutation } from '../../features/api/apiSlice'
import { useSelector, useDispatch } from 'react-redux'
import {
  Modal,
  Button,
  Icon,
  Tab,
  Header,
  Dropdown,
  Checkbox,
  Divider
} from "semantic-ui-react";
import "./FilterModal.css";


function FilterModal(props) {
  const globalFilterStarred = useSelector((state) => state.callPlayer.filterStarred);
  const globalFilterRows = useSelector((state) => state.callPlayer.filterRows);
  const globalFilterTimeframe = useSelector((state) => state.callPlayer.filterTimeframe);
  const { data:groupsData, isSuccess:isGroupsSuccess } = useGetGroupsQuery(props.shortName);
  const { data:talkgroupsData, isSuccess:isTalkgroupsSuccess } = useGetTalkgroupsQuery(props.shortName);
  const { data: favorites } = useGetFavoritesQuery(props.shortName);
  const [addFavorite] = useAddFavoriteMutation();
  const [removeFavorite] = useRemoveFavoriteMutation();
  const [selectedTalkgroup, setSelectedTalkgroup] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(false);
  const [filterStarred, setFilterStarred] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [advancedRows, setAdvancedRows] = useState([]);
  const [advancedTimeframe, setAdvancedTimeframe] = useState({ from: null, to: null });
  const dispatch = useDispatch()

  // Seed the modal from the currently-active filter each time it opens, so
  // re-opening it shows what you already have.
  useEffect(() => {
    if (props.open) {
      setFilterStarred(globalFilterStarred);
      setAdvancedRows((globalFilterRows && globalFilterRows.length > 0)
        ? globalFilterRows.map((row) => ({ ...row }))
        : []);
      const tf = globalFilterTimeframe || {};
      setAdvancedTimeframe({
        from: tf.from ? new Date(tf.from) : null,
        to: tf.to ? new Date(tf.to) : null
      });
    }
  }, [props.open, globalFilterRows, globalFilterTimeframe, globalFilterStarred]);

  const handleTabChange = (e, data) => {
    // Opening the Advanced tab with nothing in it starts you off with one row.
    if (data.activeIndex === 3 && advancedRows.length === 0) {
      setAdvancedRows([newRow()]);
    }
    setActiveTab(data.activeIndex);
  };
  const handleGroupChange = (e, { name, value }) => setSelectedGroup(value);
  const handleTalkgroupChange = (e, { name, value }) => setSelectedTalkgroup(value);
  const toggleStarred = () => setFilterStarred(!filterStarred);
  const handleClose = () => props.onClose(false);
  const onClose = props.onClose;

  const sameTalkgroups = (a, b) => a.length === b.length && a.every((num) => b.includes(num));
  const currentTalkgroupFavorite = favorites && selectedTalkgroup.length > 0 &&
    favorites.find((favorite) => favorite.type === "talkgroup" && sameTalkgroups(favorite.talkgroups, selectedTalkgroup));

  function toggleTalkgroupFavorite() {
    if (currentTalkgroupFavorite) {
      removeFavorite({ shortName: props.shortName, id: currentTalkgroupFavorite._id });
    } else {
      const label = selectedTalkgroup
        .map((num) => talkgroupList.find((tg) => tg.value === num))
        .filter(Boolean)
        .map((tg) => tg.text)
        .join(", ");
      addFavorite({
        shortName: props.shortName,
        body: { type: "talkgroup", talkgroups: selectedTalkgroup, label: label }
      });
    }
  }

  function handleDone(onClose) {
    switch (activeTab) {

      case 3: {
        // Drop empty/blank rows so a half-filled condition doesn't match nothing.
        const cleaned = advancedRows.filter((row) =>
          ["starred", "emergency"].includes(row.field) ||
          (Array.isArray(row.values) && row.values.length > 0));
        dispatch(setFilterRows(cleaned));
        dispatch(setFilterTimeframe({
          from: advancedTimeframe.from ? advancedTimeframe.from.getTime() : false,
          to: advancedTimeframe.to ? advancedTimeframe.to.getTime() : false
        }));
        props.onClose(true);
        break;
      }
      case 1:
        if (selectedGroup) {
          dispatch(setGroupFilter(selectedGroup));
          props.onClose(true);
        } else {
          props.onClose(false);
        }
        break;
      case 2:
        if (selectedTalkgroup) {
          dispatch(setTalkgroupFilter(selectedTalkgroup))
          props.onClose(true);
        } else {
          props.onClose(false);
        }
        break;
      default:
      case 0:
        dispatch(setAllFilter());
        props.onClose(true);
        break;
    }
    if (globalFilterStarred !== filterStarred) {
      dispatch(setStarredFilter(filterStarred));
    }

  }


  
  let talkgroupList = [];
  if (isTalkgroupsSuccess) {
    for (const num in talkgroupsData["talkgroups"]) {
      const talkgroup = talkgroupsData["talkgroups"][num];
      const obj = {
        key: talkgroup.num,
        value: talkgroup.num,
        text: talkgroup.description
      }
      talkgroupList.push(obj);
    }
  }

  let groupList = [];
  if (isGroupsSuccess) {
    for (const num in groupsData) {
      const group = groupsData[num]
      const obj = {
        key: group._id,
        value: group._id,
        text: group.groupName
      }
      groupList.push(obj);
    }
  }
  
  const panes = [
    {
      menuItem: 'All', render: () => {
        return (
          <Tab.Pane attached={false}>
            <Header>All Calls</Header>
            <p>Display all of the calls.</p>
          </Tab.Pane>
        )
      }
    },
    {
      menuItem: 'Groups', render: () => {
        return (
          <Tab.Pane attached={false}>
            <Dropdown placeholder='Groups' fluid search selection options={groupList} value={selectedGroup} name='selectedGroup' onChange={handleGroupChange} />

          </Tab.Pane>
        )
      }
    },
    {
      menuItem: 'Talkgroups', render: () => {
        return (
          <Tab.Pane attached={false}>
            <Dropdown placeholder='Talkgroups' fluid multiple search selection options={talkgroupList} value={selectedTalkgroup} name='selectedTalkgroup' onChange={handleTalkgroupChange} />
            <Button
              icon
              basic={!currentTalkgroupFavorite}
              color={currentTalkgroupFavorite ? 'yellow' : undefined}
              disabled={selectedTalkgroup.length === 0}
              onClick={toggleTalkgroupFavorite}
              style={{ marginTop: '1em' }}
            >
              <Icon name='star' /> {currentTalkgroupFavorite ? "Remove Favourite" : "Add Favourite"}
            </Button>
          </Tab.Pane>
        )
      }
    },
    {
      menuItem: 'Advanced', render: () => {
        return (
          <Tab.Pane attached={false}>
            <Header>Advanced Filter</Header>
            <p>Stack conditions and combine them with AND / OR.</p>
            <AdvancedFilter
              rows={advancedRows}
              onChange={setAdvancedRows}
              timeframe={advancedTimeframe}
              onTimeframeChange={setAdvancedTimeframe}
              talkgroupList={talkgroupList}
              groupList={groupList}
            />
          </Tab.Pane>
        )
      }
    },
  ]
  return (

    <Modal open={props.open} onClose={handleClose} centered={false} size={activeTab === 3 ? "small" : "tiny"}>
      <Modal.Header>Select a Filter</Modal.Header>
      <Modal.Content >
        <Modal.Description>
          <Tab menu={{ pointing: true }} panes={panes} defaultActiveIndex={activeTab} onTabChange={handleTabChange} />
          <Divider />
          <Checkbox label='Show only Starred calls' checked={filterStarred} name='filterStarred' onChange={toggleStarred} />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={()=> handleDone(onClose)} >
          <Icon name='checkmark' /> Done
        </Button>
      </Modal.Actions>
    </Modal>

  )
}

export default FilterModal;
